import { Moment } from "moment";

export * from "./propTypes";
export * from "./IAuthenticatedPerson";
export * from "./signature";

export enum ButtonTypes {
    Ok = 1,
    Yes = 2,
    No = 3
}

export enum StampDirection {
    None = 0,
    In = 1,
    Out = 2,
    Change = 3,
    Information = 4,
    Balance = 5
}

export enum StampStatus {
    Ok = 0,
    EarlyIn = 1,
    LateOut = 2,
    LateIn = 3,
    EarlyOut = 4,
    NoTask = 5,
    Emergency = 6,
    Standby = 7
}

export interface TerminalLoginResponse {
    iso639LanguageCode: string;
    autoCompleteChars: number;
    terminalName: string;
    serverVersion: string;
    selfRegistrationEnabled: boolean;
    heartBeatIntervalSec?: number;
}

export interface Config extends TerminalLoginResponse {
    terminalGuid: string;
    serverUrl: string;
    signatureRefreshSec: number;
}

export interface Coordinates {
    longitude: number;
    latitude: number;
    accuracy: number;
}

export interface StampRequest {
    costDivisionRef?: number;
    personRef: number;
    direction: string;
    deviationCodeRef?: number;
    stampDate: Moment;
    stampTime: Moment;
    coordinates: Coordinates;
}
